'use client'
import React from 'react'

import {
  ResizablePanelGroup,
  ResizablePanel,
  ResizableHandle,
} from '@/components/ui/resizable'
import { IDESidebar } from './ide-sidebar'
import { EditorTabs } from './editor-tabs'
import { CodeEditor } from './code-editor'
import { Preview } from './preview'
import { Terminal } from './terminal'
import { InteractiveTerminal } from './interactive-terminal'
import { ChatPanel } from './chat-panel'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Code, Eye, Terminal as TerminalIcon, MessageSquare } from 'lucide-react'

export function IDEWorkspace() {
  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <ResizablePanelGroup direction="horizontal">
        {/* Chat Panel */}
        <ResizablePanel defaultSize={22} minSize={18} maxSize={35}>
          <ChatPanel />
        </ResizablePanel>

        <ResizableHandle className="w-px bg-border hover:bg-primary/50 transition-colors" />

        {/* Sidebar */}
        <ResizablePanel defaultSize={15} minSize={12} maxSize={25}>
          <IDESidebar />
        </ResizablePanel>

        <ResizableHandle className="w-px bg-border hover:bg-primary/50 transition-colors" />

        {/* Main content area */}
        <ResizablePanel defaultSize={63}>
          <ResizablePanelGroup direction="horizontal">
            {/* Editor section */}
            <ResizablePanel defaultSize={50} minSize={30}>
              <ResizablePanelGroup direction="vertical">
                {/* Code editor */}
                <ResizablePanel defaultSize={70} minSize={30}>
                  <div className="h-full flex flex-col">
                    <EditorTabs />
                    <CodeEditor />
                  </div>
                </ResizablePanel>

                <ResizableHandle className="h-px bg-border hover:bg-primary/50 transition-colors" />

                {/* Terminal */}
                <ResizablePanel defaultSize={30} minSize={15} maxSize={50}>
                  <InteractiveTerminal />
                </ResizablePanel>
              </ResizablePanelGroup>
            </ResizablePanel>

            <ResizableHandle className="w-px bg-border hover:bg-primary/50 transition-colors" />

            {/* Preview section */}
            <ResizablePanel defaultSize={50} minSize={25}>
              <Preview />
            </ResizablePanel>
          </ResizablePanelGroup>
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  )
}

// Mobile/Tablet version with tabs
export function IDEWorkspaceMobile() {
  return (
    <div className="h-screen w-screen overflow-hidden bg-background flex flex-col">
      <Tabs defaultValue="chat" className="flex-1 flex flex-col">
        <TabsList className="w-full rounded-none border-b border-border justify-start bg-muted/30 px-2">
          <TabsTrigger value="chat" className="text-xs gap-1">
            <MessageSquare className="h-3 w-3" />
            Chat
          </TabsTrigger>
          <TabsTrigger value="files" className="text-xs gap-1">
            Files
          </TabsTrigger>
          <TabsTrigger value="code" className="text-xs gap-1">
            <Code className="h-3 w-3" />
            Code
          </TabsTrigger>
          <TabsTrigger value="preview" className="text-xs gap-1">
            <Eye className="h-3 w-3" />
            Preview
          </TabsTrigger>
          <TabsTrigger value="terminal" className="text-xs gap-1">
            <TerminalIcon className="h-3 w-3" />
            Terminal
          </TabsTrigger>
        </TabsList>

        <TabsContent value="chat" className="flex-1 m-0 overflow-hidden">
          <ChatPanel />
        </TabsContent>

        <TabsContent value="files" className="flex-1 m-0 overflow-hidden">
          <IDESidebar />
        </TabsContent>

        <TabsContent value="code" className="flex-1 m-0 overflow-hidden">
          <div className="h-full flex flex-col">
            <EditorTabs />
            <CodeEditor />
          </div>
        </TabsContent>

        <TabsContent value="preview" className="flex-1 m-0 overflow-hidden">
          <Preview />
        </TabsContent>

        <TabsContent value="terminal" className="flex-1 m-0 overflow-hidden">
          <Terminal />
        </TabsContent>
      </Tabs>
    </div>
  )
}
